import avo from 'analytics/avo';

// Product Configuration Interacted (CON-8954): one entry per row of the
// ticket's interaction table. `selection` is left out where the table has none.
export const PRODUCT_CONFIGURATION_INTERACTION = {
  CUSTOMIZATION_SELECTED: {
    component: 'Configuration Options',
    action: 'Selected',
    selection: 'Customization',
  },
  READY_TO_SHIP_SELECTED: {
    component: 'Configuration Options',
    action: 'Selected',
    selection: 'Ready to Ship',
  },
  DECIDE_LATER_SELECTED: {
    component: 'Configuration Options',
    action: 'Selected',
    selection: 'Decide Later',
  },
  // Turning the revamp's Decide Later toggle off, which returns to Customization
  DECIDE_LATER_CLOSED: {
    component: 'Configuration Options',
    action: 'Closed',
    selection: 'Decide Later',
  },
  FABRIC_FILTERS_OPENED: {
    component: 'Fabrics',
    action: 'Opened',
    selection: 'Filters',
  },
  FABRIC_FILTERS_CLEARED: { component: 'Fabrics', action: 'Cleared' },
  FABRICS_EXPANDED: { component: 'Fabrics', action: 'Expanded' },
  FABRICS_COLLAPSED: { component: 'Fabrics', action: 'Collapsed' },
  FREE_SWATCHES_OPENED: {
    component: 'Fabrics',
    action: 'Opened',
    selection: 'Get Free Swatches',
  },
  PROTECTION_PLAN_OPENED: { component: 'Protection Plan', action: 'Opened' },
  PROTECTION_PLAN_REMOVED: { component: 'Protection Plan', action: 'Removed' },
};

// Product Info Interacted `section` values, one per info tab / accordion row
export const PRODUCT_INFO_SECTION = {
  DIMENSIONS: 'Product Dimensions',
  DESCRIPTION: 'Product Description',
  DETAILS: 'Product Details',
  CARE: 'Product Care',
  REVIEWS: 'Product Reviews',
};

// Interactions inside a section; opening a section is sent by
// trackProductInfoSectionSelected
export const PRODUCT_INFO_INTERACTION = {
  DIMENSIONS_SELECTED: {
    section: PRODUCT_INFO_SECTION.DIMENSIONS,
    action: 'Selected',
    selection: 'Dimensions',
  },
  SHIPPING_DIMENSIONS_SELECTED: {
    section: PRODUCT_INFO_SECTION.DIMENSIONS,
    action: 'Selected',
    selection: 'Shipping Dimensions',
  },
  READ_MORE_EXPANDED: {
    section: PRODUCT_INFO_SECTION.DIMENSIONS,
    action: 'Expanded',
    selection: 'Read More',
  },
  READ_LESS_COLLAPSED: {
    section: PRODUCT_INFO_SECTION.DIMENSIONS,
    action: 'Collapsed',
    selection: 'Read Less',
  },
  EXPANDED_CONTENT_CLOSED: {
    section: PRODUCT_INFO_SECTION.DIMENSIONS,
    action: 'Closed',
  },
};

// CTA Clicked `cta` values for PDP links that open another page. `text` is the
// link's visible label, which differs by variant.
export const PDP_CTA = {
  MEASURE_FOR_DELIVERY: 'Measure for Delivery',
  PRODUCT_CARE_DETAILS: 'Product Care Details',
};

// Carousel Interacted (CON-8979) `component` values for the PDP carousels
export const PDP_CAROUSEL = {
  MORE_FROM_THE_COLLECTION: 'More from the Collection Carousel',
  RECENTLY_VIEWED: 'Recently Viewed Carousel',
  CURALATE_GALLERY: 'Curalate Gallery',
  MEASURE_FOR_DELIVERY: 'Measure for Delivery',
};

const trackCarouselInteracted = properties => {
  avo.carouselInteracted({ ...properties, location: 'PDP' });
};

// `imageIndex` only for image carousels: the 1-based slide now shown
export const trackCarouselNavigated = (component, imageIndex) => {
  trackCarouselInteracted({
    component,
    action: 'Navigated',
    ...(imageIndex ? { imageIndex } : {}),
  });
};

// `position` is the 1-based card position within the carousel
export const trackCarouselProductOpened = (component, position) => {
  trackCarouselInteracted({ component, action: 'Product Opened', position });
};

// Opening an image's detail view; `position` is the image's 1-based position
export const trackCarouselOpened = (component, position) => {
  trackCarouselInteracted({ component, action: 'Opened', position });
};

export const trackProductConfigurationInteracted = interaction => {
  avo.productConfigurationInteracted(interaction);
};

export const trackProductInfoInteracted = interaction => {
  avo.productInfoInteracted(interaction);
};

export const trackProductInfoSectionSelected = section => {
  trackProductInfoInteracted({ section, action: 'Selected' });
};

export const trackPDPCtaClicked = ({ cta, text, targetUrl }) => {
  avo.ctaClicked({ text, targetUrl, cta, location: 'PDP' });
};
